



export default {
  created() {
    this.$store.commit('dialog/CREATE', {
      title: 'Page not found',
      content: `Visit <a href="https://pleatt.com">pleatt.com</a>`,
      compact: true,
    });
  },
} as IView;
